const $ = window.jQuery;
export default function enableNav() {
  var duration =  250;

  // Change icon
  $(".dropdown[data-dropdownchild]").hover(function() {
    $(this).find('i').removeClass('fa-angle-down').addClass('fa-angle-up').css('color', '#7ba4d9');
  }, function() {
    $(this).find('i').removeClass('fa-angle-up').addClass('fa-angle-down').css('color', '');
  });

    var closeSubNav = function() {
        $('.inner-container > .inner').each(function() {
          if ($(this).hasClass('active')) {
            $(this).stop().slideUp(duration);
            $(this).removeClass('active');
          }
        });
        $('.third-container > .inner').each(function() {
          if ($(this).hasClass('active')) {
            $(this).stop().slideUp(duration);
            $(this).removeClass('active');
          }
        });
    }
  // open container if it need to be
  var openDropDown = function () {
    var itemId = $(this).attr('data-dropdownchild'),
      subnav = $('.subnav-container'),
      target = $(".subnav-wrapper[data-dropdownparent="+itemId+"]", subnav),
      wrapper = $(this).closest('ul.main-nav'),
      indicator = wrapper.find('.indicator'),
      quicklinks = $('.outside[data-quicklinksparent=' + itemId + ']');

    var newX = ($(this).offset().left - wrapper.offset().left) + ($(this).width() / 2);
    indicator.css({ 'left': newX });
    subnav.css({'top': $('nav').outerHeight()});
    if (!subnav.hasClass('active')) {
      target.show();
      quicklinks.show();
      subnav.addClass('active');
      subnav.stop().slideDown(duration, () => {});
    } else {
      target.stop().fadeIn(duration);
      quicklinks.stop().fadeIn(duration);

      $(".subnav-wrapper").not(target).hide();
      $('.outside').not(quicklinks).hide();
    }
    $(this).closest('ul.main-nav').addClass('active');
    closeSubNav()
  };

  $('.dropdown[data-dropdownchild]').mouseenter(openDropDown);
  $('.dropdown[data-dropdownchild] > a').focus(function() {
    $(this).parent().mouseenter();
  });

  var closeDropDown = function () {
    var subnav = $('.subnav-container'),
      parentId = $('.subnav-wrapper', subnav).attr('data-dropdownparent');

    subnav.slideUp(duration, function () {
      $(this).removeClass('active');
      $(".subnav-wrapper", subnav).hide();
      $('.outside').hide();
    })
    $(this).find('ul.main-nav').removeClass('active');
  }


  // close the submenu when you leave the nav all together
  $('nav').mouseleave(closeDropDown);
  $('nav').mouseleave(closeSubNav);

  // Sub navs for the mega menu
  var openSubNav = function () {
    if ($(this).hasClass('has-child')) {
      var itemId = $(this).attr('data-dropdownchild'),
        selector = '.inner-container > .inner[data-dropdownparent=' + itemId + ']',
        $subnav = $(selector);
      $('i', this).removeClass('fa-plus').addClass('fa-times');
      $('.inner-container > .inner').each(function() {
        if ($(this).hasClass('active')) {
          $(this).stop().slideUp(duration);
          $(this).removeClass('active');
        }
      });
      $('.third-container > .inner').each(function() {
        if ($(this).hasClass('active')) {
          $(this).stop().slideUp(duration);
          $(this).removeClass('active');
        }
      });
      $subnav.addClass('active');
      $subnav.stop().slideDown(duration);
    } else {
      $('.inner-container > .inner').each(function() {
        if ($(this).hasClass('active')) {
          $(this).stop().slideUp(duration);
          $(this).removeClass('active');
        }
      });
      $('.third-container > .inner').each(function() {
        if ($(this).hasClass('active')) {
          $(this).stop().slideUp(duration);
          $(this).removeClass('active');
        }
      });
    }
  };

  $('.sub-nav > li').mouseenter(openSubNav);
  $('.sub-nav > .has-child > a').focus(function () {
    $(this).parent().mouseenter();
  })

  $('.sub-nav > .has-child').mouseleave(function () {
    var itemId = $(this).attr('data-dropdownchild'),
      selector = '.inner-container > .inner[data-dropdownparent=' + itemId + ']',
      $subnav = $(selector);
    $('i', this).addClass('fa-plus').removeClass('fa-times');
    if ($subnav.hasClass('active')) {
      return false;
    }
    $subnav.stop().slideUp(duration);
  });

  // Sub-sub navigation
  var openSubSubNav = function () {
    var itemId = $(this).attr('data-dropdownchild'),
      selector = '.third-container > .inner[data-dropdownparent=' + itemId + ']',
      $subnav = $(selector);
    $('i', this).removeClass('fa-plus').addClass('fa-times');
    if ($('.third-container > .inner').hasClass('active')) {
      $('.third-container > .inner').stop().slideUp(duration);
      $('.third-container > .inner').removeClass('active');
    }
    $subnav.addClass('active');
    $subnav.stop().slideDown(duration);
  };

  $('.inner-container > .inner > .has-child').mouseenter(openSubSubNav);
  $('.inner-container > .inner > .has-child > a').focus(function() {
    $(this).parent().mouseenter();
  })

  $('.inner-container > .inner > .has-child').mouseleave(function () {
    var itemId = $(this).attr('data-dropdownchild'),
      selector = '.third-container > .inner[data-dropdownparent=' + itemId + ']',
      $subnav = $(selector);
    $('i', this).removeClass('fa-times').addClass('fa-plus');
    if ($subnav.hasClass('active')) {
      return false;
    }
    $subnav.removeClass('active');
    $subnav.stop().slideUp(duration);
  });


  // Set the tabindex for the navigation, starting at 2, so it is after the
  // toolbar menu
  var i = 2;
  $('.dropdown').each(function() {
    var id = $(this).attr('data-dropdownchild');
    $('a', this).attr('tabindex', i++);

    $('.subnav-wrapper[data-dropdownparent=' + id + '] > .sub-nav > li').each(function() {
      $('a', this).attr('tabindex', i++);
      var subId = $(this).attr('data-dropdownchild');

      $('.inner[data-dropdownparent=' + subId + ']').each(function() {
        $('a', this).attr('tabindex', i++);
        var subSubId = $(this).attr('data-dropdownchild');

        $('.inner[data-dropdownparent=' + subSubId + ']').each(function() {
          $('a', this).attr('tabindex', i++);
        });
      });
    });

    $('.outside[data-quicklinksparent=' + id +'] > div').each(function() {
      $('a', this).attr('tabindex', i++);
    });

    i++;
  })
}



/** WEBPACK FOOTER **
 ** ./src/assets/foi/js/nav.js
 **/